interface NavigatorType extends Navigator {
    brave?: never
}

/**
 * The snippet const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent); from vista-digital
 * occ repo does not work.
 * Major iOS browser agents have following unique signatures:
 *  - Chrome: CriOS. Reference: https://whatmyuseragent.com/browser/ci/chrome-mobile-ios/99
 *  - Opera: OPT. Reference: No reference. Found signature on portfowarded localhost outputting window.navigator.userAgent
 *  running on real iphone opera browser.
 *  - Opera: Mini. OPiOS. Reference: https://whatmyuseragent.com/browser/o1/opera-mini-ios
 *  - Opera GX: OPX. Reference: https://whatmyuseragent.com/browser/ox/opera-gx
 *  - Firefox: FxiOS. Reference: https://whatmyuseragent.com/browser/f1/firefox-mobile-ios/99
 *  - UCBrowser: UCBrowser. Reference: https://user-agents.net/browsers/uc-browser/platforms/ios
 *  - Edge: EdgiOS. Reference: https://user-agents.net/browsers/edge/platforms/ios
 *
 *  Brave has window.navigator.brave in navigator. https://community.brave.com/t/detect-if-user-is-using-brave-as-browser-when-navigates-on-my-website/473611.
 *  Verified this on portfowarded localhost outputting window.navigator.userAgent
 *  running on real iphone brave browser
 * **/
const isSafari: () => boolean = () => {
    const uniqueUserAgentSignatures = ['CriOS', 'OPT', 'OPiOS', 'OPX', 'FxiOS', 'UCBrowser', 'EdgiOS']
    const isBrave = (() => {
        const navigatorInstance: NavigatorType = navigator
        return !!navigatorInstance.brave
    })()
    return !!(
        navigator.vendor &&
        navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        navigator.userAgent.includes('Safari') &&
        !uniqueUserAgentSignatures.some(signature => navigator.userAgent.includes(signature)) &&
        !isBrave
    )
}

export default isSafari
